export default __webpack_public_path__ + "static/media/Group 11.f0ac9e26.png";